'use client';

import { useIsLoading, useIsLogined } from '@/contexts/LoginContext';
import { SeoTextBlock } from '.';

type Props = {
  header: string;
  seoText: string;
  initialIsLoggedIn: boolean;
};

export function GuestSeoTextBlock({ header, seoText, initialIsLoggedIn }: Props) {
  const isLogined = useIsLogined();
  const isLoading = useIsLoading();
  const isLoggedIn = isLoading ? initialIsLoggedIn : isLogined;

  if (isLoggedIn) {
    return null;
  }

  return <SeoTextBlock header={header} seoText={seoText} />;
}
